module.exports = __webpack_public_path__ + "static/media/cesped_sport.23932f87.jpg";